import { Component, inject } from '@angular/core';
import { Card } from 'primeng/card';
import { DokumentApi } from '../../../shared/services/api/dokument.api';
import { DefinicjeParametrow } from '../../../shared/enums/params-definition.enum';
import { catchError, tap, throwError } from 'rxjs';
import { HttpResponseService } from '../../../core/services/http-error-response.service';
import { InfoMessageComponent } from '../../../shared/components/info-message/info-message.component';

@Component({
  selector: 'app-auth-tech-requirements-and-manual',
  imports: [Card, InfoMessageComponent],
  templateUrl: './auth-tech-requirements-and-manual.html',
  styleUrl: './auth-tech-requirements-and-manual.scss',
})
export class AuthTechRequirementsAndManualComponent {
  readonly #dokumentApi = inject(DokumentApi);
  readonly #httpResponseService = inject(HttpResponseService);

  protected redirectToManualInstruction(): void {
    this.#dokumentApi
      .getParamContent$(DefinicjeParametrow.ADRES_INSTRUKCJA)
      .pipe(
        tap((response: string) => {
          if (response) {
            window.open(response, '_blank', 'noopener,noreferrer');
          }
        }),
        catchError((err) => {
          this.#httpResponseService.showErrorMessage(
            err,
            'Wystąpił błąd podczas pobrania instrukcji użytkownika',
          );
          return throwError(() => err);
        }),
      )
      .subscribe();
  }
}
